module.exports = "https://coursera_assets.s3.amazonaws.com/images/1b0cea526b6c74fa63a856dc5c6c236c.png";